import { useCallback, useEffect, useState } from "react";
import * as awarenessProtocol from "y-protocols/awareness";
import { ACTIONS_ID, SERVER_ID } from "./YFSClient";

export function useAwarenessEntries(awareness: awarenessProtocol.Awareness) {
  const getAwarenessEntries = useCallback(() => {
    return Array.from(awareness.getStates().entries())
      .filter(([clientId]) => clientId !== SERVER_ID)
      .filter(([clientId]) => clientId !== ACTIONS_ID)
      .filter(([clientId]) => clientId !== awareness.clientID)
      .sort(([clientId1], [clientId2]) => {
        if (clientId1 < clientId2) return -1;
        if (clientId2 > clientId1) return 1;
        return 0;
      });
  }, [awareness]);

  const [awarenessEntries, setAwarenessEntries] = useState(getAwarenessEntries());

  useEffect(() => {
    const updateAwarenessEntries = () => setAwarenessEntries(getAwarenessEntries());
    awareness.on("change", updateAwarenessEntries);
    return () => {
      awareness.off("change", updateAwarenessEntries);
    };
  }, [awareness, getAwarenessEntries]);

  return awarenessEntries;
}
